
















































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";
import { PaperBugFixedForm } from "../model/PaperBugFixedForm";
import {
  MachineGlueFixedFormCost,
  MachineGlueBoxUnitCost,
  MachineGlueCost,
  ManualGlueProductivityCost
} from "../model/Cost";
import { getCalcTypes } from "../model/CalcType";
import { BoxType } from "../model/BoxType";

@Component
export default class GlueEditComp extends HacoBase {
  editData: any = {};
  $debugServer!: string;
  defData: any = {};
  costTypeA = true;
  costTypeB = false;
  defMachineGlueCost!: MachineGlueCost;
  calcTypes: { [key: string]: string } = getCalcTypes();
  // calcTypeKey = "hacoplay";

  mounted(): void {
    let editId: number;
    if (this.$route.params.id === undefined) {
      return;
    } else {
      editId = parseInt(this.$route.params.id, 10);
      this.defMachineGlueCost = new MachineGlueCost();
      this.defData = {
        id: editId,
        itemGlueName: "",
        costType: "manual",
        calcType: "hacoplay",
        machineRunningMinCost: null,
        manualGlueProductivityCosts: [],
        manualGluePreparationCosts: {
          itemGlueId: editId,
          costPerHour: 0,
          preparationTimePerMin: 0
        },
        machineGlueCosts: null,
        machineGlueFixedFormCosts: null,
        machineGlueBoxUnitCosts: []
      };

      const url =
        this.$debugServer +
        "/api/v1_inner/glue/" +
        this.$route.params.id +
        "/edit";
      const accessMethod = "get";
      /** 新規の場合 */
      if (editId === -1) {
        this.costTypeA = true;
        this.costTypeB = false;
      }
      const params: object = this.setAxiosParams(url, accessMethod);

      axios(params)
        .then((response: any): void => {
          const defManualGlueProductivityCosts: ManualGlueProductivityCost[] = [];
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const boxTypes: BoxType[] = response.data.boxTypes;
          boxTypes.forEach(boxType => {
            defManualGlueProductivityCosts.push({
              itemGlueId: editId,
              boxTypeId: boxType.id || 0,
              cost: 0
            });
          });
          const fixForms: PaperBugFixedForm[] =
            response.data.paperBugFixedForms;
          this.defData.manualGlueProductivityCosts = defManualGlueProductivityCosts;
          if (response.data.paperBugFixedForms) {
            this.defData.machineGlueFixedFormCosts = [
              fixForms.map(paperBugFixedForm => {
                const machineGlueFixedFormCost = new MachineGlueFixedFormCost();
                machineGlueFixedFormCost.itemGlueId = editId;
                machineGlueFixedFormCost.paperBugFixedFormId =
                  paperBugFixedForm.id;
                return machineGlueFixedFormCost;
              })
            ];
          }

          if (response.data.boxTypes) {
            this.defData.machineGlueBoxUnitCosts = boxTypes.map(boxType => {
              const machineGlueBoxUnitCost = new MachineGlueBoxUnitCost();
              machineGlueBoxUnitCost.boxTypeId =
                boxType.id === 0 ? 0 : boxType.id ? boxType.id : -1;
              return machineGlueBoxUnitCost;
            });
            //console.log(this.defData.machineGlueBoxUnitCosts);
            // this.defData.machineGlueBoxUnitCosts =
          }
          /** 新規の場合 */
          if (editId === -1) {
            this.editData = {
              glue: this.defData,
              boxTypes: boxTypes,
              paperBugFixedForms: fixForms
            };
          } else {
            this.editData = response.data;
          }
          if (this.editData.glue.costType === "manual") {
            this.costTypeA = true;
            this.costTypeB = false;
          } else {
            this.costTypeA = false;
            this.costTypeB = true;
            this.$nextTick(this.calcPageHeight);
          }
        })
        .catch((error: any): void => {
          console.log("[mount error]", error);
          this.toLoginPage(error);
        });
    }
  }

  getBoxTypeFilters(): BoxType[] {
    const calcType = this.editData.glue.calcType;
    return this.editData.boxTypes.filter((boxType: BoxType) => {
      return (
        (calcType === "hacoplay" && !Number(boxType.isPaperBug)) ||
        (calcType === "paperBug" && Number(boxType.isPaperBug))
      );
    });
  }

  checkInputKeys(e: KeyboardEvent): void {
    if (e.ctrlKey === true && e.key === "Enter") {
      this.onSubmit();
    }
  }

  //getById(data: any[], id: number): any {}

  onSubmit(back = false): void {
    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }
    const editData: any = this.editData;
    const bool: boolean = this.resetSheetFromEle();
    if (bool === true) {
      return;
    }

    if (editData.glue.costType === "machine") {
      this.setSheetFrom();
      let sheetValueCheck: number[];
      if (editData.glue.calcType === "hacoplay") {
        sheetValueCheck = this.checkSheetValue(editData.glue.machineGlueCosts);
      } else {
        sheetValueCheck = this.checkFixFormSheetValue(
          editData.glue.machineGlueFixedFormCosts
        );
      }
      /** quantityFromおかしかったらエラー出す */
      if (sheetValueCheck[1] !== -1) {
        this.showSheetFromError(sheetValueCheck);
        return;
      }
      /** 問題なかったらsheetToの値を設定 */
      this.setSheetTo();
      editData.glue.manualGluePreparationCosts = null;
      editData.glue.manualGlueProductivityCosts = null;
      if (editData.glue.calcType === "hacoplay") {
        editData.glue.machineGlueFixedFormCosts = null;
      } else {
        editData.glue.machineGlueCosts = null;
      }
    } else {
      editData.glue.machineRunningMinCost = null;
      editData.glue.machineGlueCosts = null;
    }

    /** 表記の揺れ対策 */
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "glue",
      backTo: "Glue",
      dataName: "glue"
    };
    const id: number = parseInt(editData.glue.id, 10);
    // console.log(editData);
    // console.log(categoryObj, back, id);
    this.sendEditData(id, editData, categoryObj, back, this.afterSaving);
  }

  afterSaving(): void {
    void 0;
  }

  addCell(arr: any[]): void {
    const len: number = arr.length - 1;
    interface NewItem {
      itemGlueId: number;
      boxTypeId: number;
      quantityFrom: number;
      quantityTo: number;
      cost: number;
    }
    const newItems: NewItem[] = [];
    let i = 0;
    for (const item of arr[len]) {
      newItems[i] = {
        itemGlueId: item.itemGlueId,
        boxTypeId: item.boxTypeId,
        quantityFrom: item.quantityFrom,
        quantityTo: item.quantityTo,
        cost: parseFloat(item.cost)
      };
      i += 1 | 0;
    }
    let quantityFrom: any = newItems[0].quantityFrom;
    quantityFrom = parseInt(quantityFrom, 10);
    const sheetFrom: number = quantityFrom + 1;
    let item: NewItem;
    for (item of newItems) {
      item.quantityFrom = sheetFrom;
    }
    arr.push(newItems);
  }

  addFixFormCell(arr: any): void {
    if (arr.length !== 0 && arr !== undefined) {
      const lastDataList = arr
        .slice()
        .pop()
        .map((item: MachineGlueFixedFormCost) => ({ ...item }));
      if (lastDataList) {
        const lastData = lastDataList.slice().shift();
        if (lastData) {
          const addData = lastDataList.map((data: MachineGlueFixedFormCost) => {
            data.sheetFrom = lastData.sheetFrom + 1;
            return data;
          });
          arr.push(addData);
        }
      }
    }
    this.calcPageHeight();
  }

  /** quantityFromをすべての配列に設定 */
  setSheetFrom(): void {
    if (this.editData.glue.machineGlueCosts) {
      for (const item of this.editData.glue.machineGlueCosts) {
        const quantityFrom: number = parseInt(item[0].quantityFrom, 10);
        for (const cost of item) {
          cost.quantityFrom = quantityFrom;
          cost.cost = parseFloat(cost.cost);
        }
      }
    }
    this.editData.glue.machineGlueFixedFormCosts.map(
      (lists: MachineGlueFixedFormCost[]) => {
        const data = lists[0] as MachineGlueFixedFormCost;
        const sheetFrom = data.sheetFrom;
        lists.map((item: MachineGlueFixedFormCost) => {
          item.sheetFrom = sheetFrom;
          return item;
        });
      }
    );
  }

  /** sheetToの値を設定する */
  setSheetTo(): void {
    const arr: any[] = this.editData.glue.machineGlueCosts;
    if (!arr || !arr.length) {
      return;
    }
    let i: number;
    let j: number;
    const glueId: number = this.editData.glue.id;
    for (i = 0; i < arr.length; i++) {
      j = i + 1;
      for (const item of arr[i]) {
        /** itemGlueId(新規継続対策) */
        item.itemGlueId = glueId;
        item.quantityTo = arr[j] ? arr[j][0].quantityFrom - 1 : -1;
      }
    }
    const reverseList = this.editData.glue.machineGlueFixedFormCosts.reverse();
    let lastData = new MachineGlueFixedFormCost();
    reverseList.map((lists: MachineGlueFixedFormCost[]) => {
      if (!lastData.sheetFrom) {
        Object.values(lists).map((item: MachineGlueFixedFormCost) => {
          item.sheetTo = -1;
        });
      } else {
        Object.values(lists).map((item: MachineGlueFixedFormCost) => {
          item.sheetTo = lastData.sheetFrom - 1;
        });
      }
      lastData = lists[0];
    });
    reverseList.reverse();
  }

  checkSheetValue(arr: any[]): number[] {
    if (!arr || !arr.length) {
      return [0, -1];
    }
    let quantityFrom: number = parseInt(arr[0][0].quantityFrom, 10) as number;
    let prevFrom: number;
    let erroredNumber = -1;
    let i = 1;
    for (i = 1; i < arr.length; i++) {
      prevFrom = parseInt(arr[i][0].quantityFrom, 10);
      if (prevFrom <= quantityFrom) {
        erroredNumber = quantityFrom;
        break;
      } else {
        quantityFrom = prevFrom;
      }
    }
    return [i, erroredNumber];
  }

  checkFixFormSheetValue(arr: any[]): number[] {
    if (!arr || !arr.length) {
      return [0, -1];
    }
    let quantityFrom: number = parseInt(arr[0][0].sheetFrom, 10) as number;
    let prevFrom: number;
    let erroredNumber = -1;
    let i = 1;
    for (i = 1; i < arr.length; i++) {
      prevFrom = parseInt(arr[i][0].sheetFrom, 10);
      if (prevFrom <= quantityFrom) {
        erroredNumber = quantityFrom;
        break;
      } else {
        quantityFrom = prevFrom;
      }
    }
    return [i, erroredNumber];
  }

  /** コストタイプ変更 */
  changeCostType(costType: string): void {
    const data: any = this.editData.glue;
    data.costType = costType;
    this.editData.glue.costType = costType;
    /** 初期値を設定する  */
    if (costType === "machine") {
      if (
        this.editData.glue.machineGlueCosts === null ||
        this.editData.glue.machineGlueCosts.length === 0
      ) {
        this.editData.glue.machineGlueCosts = [];
        this.editData.glue.machineGlueCosts[0] = [];

        this.editData.boxTypes.map((boxType: BoxType) => {
          const machineGlueCost = new MachineGlueCost();
          machineGlueCost.boxTypeId = boxType.id || 0;
          this.editData.glue.machineGlueCosts[0].push(machineGlueCost);
        });
      }
      if (
        !this.editData.glue.machineGlueFixedFormCosts ||
        this.editData.glue.machineGlueFixedFormCosts.length === 0
      ) {
        const idFormCosts = this.editData.paperBugFixedForms.map(
          (paperBugFixedForm: PaperBugFixedForm) => {
            const machineGlueFixedFormCost = new MachineGlueFixedFormCost();
            machineGlueFixedFormCost.paperBugFixedFormId = paperBugFixedForm.id;
            return machineGlueFixedFormCost;
          }
        );
        this.editData.glue.machineGlueFixedFormCosts = [idFormCosts];
      }
      if (
        !this.editData.glue.machineGlueBoxUnitCosts ||
        this.editData.glue.machineGlueBoxUnitCosts.length === 0
      ) {
        this.editData.glue.machineGlueBoxUnitCosts = this.editData.boxTypes.map(
          (boxType: BoxType) => {
            const machineGlueBoxUnitCost = new MachineGlueBoxUnitCost();
            machineGlueBoxUnitCost.boxTypeId =
              boxType.id === 0 ? 0 : boxType.id ? boxType.id : -1;
            return machineGlueBoxUnitCost;
          }
        );
      }
      // console.log(this.editData.glue.machineGlueBoxUnitCosts);
      this.$nextTick(this.calcPageHeight);
    } else {
      if (this.editData.glue.manualGluePreparationCosts === null) {
        this.editData.glue.manualGluePreparationCosts = Object.assign(
          {},
          this.defData.manualGluePreparationCosts
        );
      }
      if (
        this.editData.glue.manualGlueProductivityCosts === null ||
        this.editData.glue.manualGlueProductivityCosts.length === 0
      ) {
        this.editData.glue.manualGlueProductivityCosts = this.defData.manualGlueProductivityCosts;
      }
    }
  }

  addCellBridge(data: any) {
    this.addCell(data);
    this.calcPageHeight();
  }

  deleteCellBridge(i: number, data: any) {
    this.deleteCell(i, data);
    this.calcPageHeight();
  }

  calcPageHeight(): void {
    const editForm: HTMLElement = document.getElementById(
      "editForm"
    ) as HTMLElement;
    const addableTable: HTMLTableElement = document.getElementById(
      "addableTable"
    ) as HTMLTableElement;
    if (!addableTable) {
      return;
    }
    editForm.style.height = "auto";
    addableTable.style.position = "static";
    this.$nextTick((): void => {
      const pageHeight = editForm.offsetHeight;
      editForm.style.height = pageHeight + "px";
      addableTable.style.position = "absolute";
    });
  }
}
